import PaginatedResponse from '../base/paginatedResponse'
import { ObjectType } from '@nestjs/graphql'
import { NotificationDto } from './model.dto'

@ObjectType()
export class NotificationPagedResultDto extends PaginatedResponse(NotificationDto) {
}
